export default function(options) {
    return (APPLICATION !== 'author') ? options.fn(this) : options.inverse(this);
}
